"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FormProvider } from "@/integrations/forms/FormProvider";
export default function ShopContent() {
  return <section data-section-id="222568" id="shop-content" className="bg-background text-foreground px-4 py-32 sm:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="font-serif text-5xl md:text-6xl font-normal text-foreground tracking-tight">
              Coming Soon
            </h1>
            <p className="font-default text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              We are currently curating a premium selection of wellness essentials and medical-grade protocols. Our new Shopify experience is launching soon to bring MO Protocol directly to your doorstep.
            </p>
          </div>

          <div className="pt-8">
            <div className="bg-card p-8 md:p-12 rounded-2xl border border-border shadow-sm">
              <FormProvider formId="shop-launch-notify">
                <form className="space-y-6">
                  <div className="space-y-2 text-left">
                    <Label htmlFor="email" className="font-default text-sm font-medium text-foreground ml-1">
                      Be the first to know when we launch
                    </Label>
                    <div className="flex flex-col sm:flex-row gap-3">
                      <Input id="email" name="email" type="email" placeholder="your@email.com" required className="h-12 rounded-lg border-border bg-background focus-visible:ring-[var(--color-green-accent)]" />
                      <Button type="submit" className="h-12 px-8 rounded-lg bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90 font-default font-semibold transition-colors">
                        Notify Me
                      </Button>
                    </div>
                  </div>
                  <p className="text-xs text-muted-foreground font-default">
                    By subscribing, you agree to receive updates about our shop launch and exclusive offers.
                  </p>
                </form>
              </FormProvider>
            </div>
          </div>

          <div className="pt-12 flex justify-center gap-8">
            <div className="flex flex-col items-center gap-2">
              <span className="text-[var(--color-gold-accent)] font-serif text-2xl">01</span>
              <span className="text-xs uppercase tracking-widest text-muted-foreground font-default">Curation</span>
            </div>
            <div className="h-12 w-px bg-border self-center" />
            <div className="flex flex-col items-center gap-2">
              <span className="text-[var(--color-gold-accent)] font-serif text-2xl">02</span>
              <span className="text-xs uppercase tracking-widest text-muted-foreground font-default">Integration</span>
            </div>
            <div className="h-12 w-px bg-border self-center" />
            <div className="flex flex-col items-center gap-2 opacity-40">
              <span className="text-foreground font-serif text-2xl">03</span>
              <span className="text-xs uppercase tracking-widest text-muted-foreground font-default">Launch</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}